import Styles from "../editScreenStyles.module.css";
import { BehalfOfOptions, userTypes } from "../../../../constants/options";

function YourInfoEdit({
  fields,
  utilities,
 updateClicked,
 cancelClicked,
}) {
  const {
    createEditScreenInput,
    createToggleInput,
    createCustomLabelSelect,
  } = utilities;

  return (
    <div>
      <div className={Styles.title}>Your Information</div>
      <div className={Styles.column}>
        <div className={Styles.row}>
          {createEditScreenInput(fields.contactFirstName, "50%", Styles.input, Styles.label)}
          {createEditScreenInput(fields.contactLastName, "50%", Styles.input, Styles.label)}
        </div>
        <div className={Styles.row}>
          {createEditScreenInput(fields.contactEmail, "50%", Styles.input, Styles.label)}
          {createEditScreenInput(fields.confirmEmail, "50%", Styles.input, Styles.label, { altLabel: "Confirm" })}
        </div> 
        <div className={Styles.row}>
          {createEditScreenInput(fields.contactPhone, "50%", Styles.input, Styles.label)}
        </div>
        <div className={Styles.centeredColumn}>
          {createToggleInput(fields.userType, "70%", userTypes, true)}
          
          {fields.userType.value === userTypes[1].value && (
            <>
              <div className={Styles.row}>
                {createCustomLabelSelect(
                  fields.onBehalfOf,
                  BehalfOfOptions,
                  Styles.select,
                  `required-field-before ${Styles.label}`,
                  { altLabel: "Filing On Behalf Of", placeholder: ""}
                )}
              </div>
              {fields.onBehalfOf.value === BehalfOfOptions[1] && (
                <>
                  <div className={Styles.row}>
                    <p
                      style={{
                        fontSize: ".9rem",
                        fontWeight: 600,
                        marginTop: ".5rem",
                      }}
                    >
                      Who is the third-party claimant?
                    </p>
                  </div>
                  <div className={Styles.row}>
                    {createEditScreenInput(fields.behalfOfFirst, "50%", Styles.input, Styles.label)}
                    {createEditScreenInput(fields.behalfOfLast, "50%", Styles.input, Styles.label)}
                  </div>
                </>
              )}
            </>
          )}
        </div>
        <div className={Styles.buttons}>
          <button
            type="button"
            className={Styles.button}
            onClick={cancelClicked}
          >
            Cancel
          </button>
          <button
            type="button"
            className={Styles.button}
            onClick={updateClicked}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default YourInfoEdit;
